import { axiosPrivate } from "@/api/axios";
import API_ROUTES from "@/api/apiRoutes";
import { Card, CardType } from "../types";

// ─── Card Types ────────────────────────────────────────────────────────────────

export async function fetchAllCardTypes(): Promise<CardType[]> {
  const res = await axiosPrivate.get("/cards/types");
  const payload = res.data?.data ?? res.data?.results ?? res.data;
  return Array.isArray(payload) ? (payload as CardType[]) : [];
}

export async function fetchCardTypeById(id: number): Promise<CardType> {
  const res = await axiosPrivate.get(API_ROUTES.CARDS.TYPES.BY_ID(id));
  return (res.data?.data ?? res.data) as CardType;
}

export async function createCardType(data: { type: string; description?: string }): Promise<CardType> {
  const res = await axiosPrivate.post(API_ROUTES.CARDS.TYPES.BASE, data);
  return (res.data?.data ?? res.data) as CardType;
}

export async function updateCardType(
  id: number,
  data: { type?: string; description?: string }
): Promise<CardType> {
  const res = await axiosPrivate.put(API_ROUTES.CARDS.TYPES.BY_ID(id), data);
  return (res.data?.data ?? res.data) as CardType;
}

export async function deleteCardType(id: number): Promise<void> {
  await axiosPrivate.delete(API_ROUTES.CARDS.TYPES.BY_ID(id));
}

// ─── Cards ─────────────────────────────────────────────────────────────────────

export async function fetchAllCards(): Promise<Card[]> {
  const res = await axiosPrivate.get(API_ROUTES.CARDS.ALL);
  const payload = res.data?.data ?? res.data;
  return Array.isArray(payload) ? (payload as Card[]) : [];
}

export async function fetchCardsByType(cardTypeId: number): Promise<Card[]> {
  const res = await axiosPrivate.get(API_ROUTES.CARDS.BY_TYPE, {
    params: { card_type_id: cardTypeId },
  });
  const payload = res.data?.data ?? res.data;
  return Array.isArray(payload) ? (payload as Card[]) : [];
}

export async function fetchCardById(id: number): Promise<Card> {
  const res = await axiosPrivate.get(API_ROUTES.CARDS.BY_ID(id));
  return (res.data?.data ?? res.data) as Card;
}

export async function createCard(data: {
  content: string;
  image_url?: string;
  card_type_id?: number;
}): Promise<Card> {
  const res = await axiosPrivate.post(API_ROUTES.CARDS.BASE, data);
  return (res.data?.data ?? res.data) as Card;
}

export async function updateCard(
  id: number,
  data: { content?: string; image_url?: string; card_type_id?: number }
): Promise<Card> {
  const res = await axiosPrivate.put(API_ROUTES.CARDS.BY_ID(id), data);
  return (res.data?.data ?? res.data) as Card;
}

export async function deleteCard(id: number): Promise<void> {
  await axiosPrivate.delete(API_ROUTES.CARDS.BY_ID(id));
}
